import { RecipientsHelper } from '@getaccept/lib-shared/src/recipients/helpers/recipients.helper';
import type { MaybeRef } from '@vueuse/core';
import { computed, unref } from 'vue';
import { capitalizeFirstLetter } from '@getaccept/lib-shared/src/helpers';

export const useRecipientSearch = (searchInput: MaybeRef<string>) => {
  const trimmedSearchInput = computed(() => unref(searchInput).trim());

  const isOnlyNumbers = computed(() => /^\d+$/.test(trimmedSearchInput.value));

  const data = computed(() => {
    if (isOnlyNumbers.value) {
      return { mobile: unref(searchInput) };
    }
    if (unref(searchInput).includes('@')) {
      return { ...RecipientsHelper.getRecipientDataFromEmail(unref(searchInput)) };
    }
    const firstName = capitalizeFirstLetter(unref(searchInput)).trim();
    const lastName = capitalizeFirstLetter(unref(searchInput).substring(firstName.length));
    return { firstName, lastName };
  });

  return { data };
};
